import ThisModule from "./PageContact";

export default ThisModule;
